// JavaScript Document
//東京 TWJ 池田作成 2023-04-14

 $(function(){

$("a.slideshow__btn").each(function(){

var slideshowSlide = $(this).parents('div.slideshow__slide');
var thisLink = $(this).attr('href');
var thisText = $(this).text();

$(slideshowSlide).wrapInner('<a class="addLink">')
$("a.addLink").attr("href",thisLink);

  });

 });

